import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { SpinnerComponent } from '../../shared/spinner/spinner.component';
import { LookupService } from '../../services/lookup.service';
import { ProjectDetailsService } from '../../services/project-details.service';
import { SlurryService } from '../../services/slurry.service';
import { SlurryDetailsComponent } from '../slurry-details/slurry-details.component';

@Component({
  selector: 'app-slurry-batch-details',
  imports: [CommonModule, FormsModule, SpinnerComponent],
  templateUrl: './slurry-batch-details.component.html',
  styleUrls: ['../slurry-details/slurry-details.component.css', './slurry-batch-details.component.css']
})
export class SlurryBatchDetailsComponent extends SlurryDetailsComponent {
  constructor(
    route: ActivatedRoute,
    router: Router,
    lookupService: LookupService,
    slurryService: SlurryService,
    dialog: MatDialog,
    projectDetailsService: ProjectDetailsService
  ) {
    super(route, router, lookupService, slurryService, dialog, projectDetailsService);
  }

  getBreadcrumbSlurryLabel(): string {
    const trimmedUfid = this.ufid?.trim();
    if (trimmedUfid) {
      return trimmedUfid;
    }

    return this.slurryId > 0 ? `Slurry #${this.slurryId}` : 'Slurry Details';
  }
}
